import { render, staticRenderFns } from "./messageExample.vue?vue&type=template&id=6a147fda&"
import script from "./messageExample.vue?vue&type=script&lang=js&"
export * from "./messageExample.vue?vue&type=script&lang=js&"
import style0 from "./messageExample.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports